import { Canvas } from '@react-three/fiber';
import { ContactShadows, OrbitControls, PerspectiveCamera } from '@react-three/drei'
import { Modal, Spin, message } from 'antd';
import { useState } from 'react';
import liracrypt from '../components/Liracrypt/liracrypt';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';
import DTModal from '../components/3DModels/DTModal';
import { PwsLineModel03 } from '../components/3DModels/PwsLine03';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

export default function DigitalTwin() {
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const [modal, setModal] = useState({
        open: false,
        api: '',
        loading: false,
        typ: '',
        data: null
    });

    const toggleModal = ({ open = false, data = undefined, loading = false, typ = '', api = '' }) => {
        setModal({ open, data, loading, typ, api });
    }

    const openPopup = ({ objectId, typ }) => {
        if (typ === 'dynamicZenChart') {
            toggleModal({
                open: true,
                api: '/digitaltwin/dashboard',
                loading: false,
                data: {
                    ...searchParams,
                    // dn: 'DynamicZenChartMultiRow1',
                    objectId
                },
                typ
            });
            return;
        }
        toggleModal({
            open: true,
            loading: true,
            data: undefined,
            // typ: 'widget'
        })
        liracrypt.get('/digitaltwin/dashboard', { dn: 'DtPopup1', objectId })
            .then(({ data }) => {
                if (data.isSuccess) {
                    toggleModal({
                        open: true,
                        loading: false,
                        typ: 'widget',
                        data: { ...data.config, objectId, searchParams: { ...searchParams } }
                    })
                } else {
                    message.error('something went wrong');
                }
            }).catch(err => {
                ApiErrorComp();
            })
    }

    return (
        <div className='App' style={{ height: '100vh', background: '#ffffff' }}>
            <Canvas gl={{ toneMappingExposure: 1 }}>
                <directionalLight position={[10, 10, 5]} intensity={2} />
                <directionalLight position={[-10, -10, -5]} intensity={1} />
                <PwsLineModel03 openDetail={({ objectId, typ }) => {
                    openPopup({ objectId, typ })
                }} position={[-100, -5, 80]} scale={20} rotation-y={-Math.PI / 2} />
                <ContactShadows renderOrder={2} frames={1} resolution={1024} scale={120} blur={2} opacity={0.6} far={10} />
                <OrbitControls enableZoom={true} enablePan={true} minPolarAngle={0} maxPolarAngle={Math.PI / 2.25} makeDefault />
                <PerspectiveCamera makeDefault position={[500, 0.9, 500]}
                    fov={40}
                    zoom={3} />
            </Canvas>
            {/* <Modal title="Modal" onCancel={() => setOpenModal(false)} className='digital-twin-modal' okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }} open={openModal}>
                <ul className='digital-twin-list'>
                    <li>
                        <img height={50} width={50} src={require('../assets/static/DTM.png')} />
                        <p style={{ fontSize: "20px", marginBottom: 0 }} >Part No</p> </li>
                    <li><img height={50} width={50} src={require('../assets/static/D.png')} />
                        <p style={{ fontSize: "20px", marginBottom: 0 }}>{'cardData?.partName'}</p> </li>
                    <li><img height={50} width={50} src={require('../assets/static/H.png')} /> <p style={{ fontSize: "20px", marginBottom: 0 }}>{'cardData?.binCode'}</p> </li>
                    <li><img height={50} width={50} src={require('../assets/static/PDT.png')} /> <p style={{ fontSize: "20px", marginBottom: 0 }}>{'cardData?.qty'}</p> </li>
                    <li><img height={50} width={50} src={require('../assets/static/I.png')} /> <p style={{ fontSize: "20px", marginBottom: 0 }}>{'cardData?.loc'}</p> </li>
                    <li><img height={50} width={50} src={require('../assets/static/MST.png')} /> <p style={{ fontSize: "20px", marginBottom: 0 }}>{'cardData?.aux1'}</p> </li>
                    <li><img height={50} width={50} src={require('../assets/static/X.png')} /> <p style={{ fontSize: "20px" }}>{'cardData?._id'}</p> </li>
                </ul>
            </Modal> */}
            {/* <Modal direction={'ltr'} width={"65%"} title="Line Status" className='digital-twin-modal' onCancel={
                () => toggleModal({ open: false, data: undefined, loading: false })
            } okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }} open={modal.open}>
                {
                    modal.loading ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Spin indicator={<LoadingOutlined spin style={{ fontSize: 70, color: '#ffffff' }} />} />
                        </div> :
                        <div>
                            <DtWidget data={modal.data} />
                        </div>
                }

            </Modal> */}
            {
                modal.open && (
                    <DTModal modal={modal} toggleModal={toggleModal} />
                )
            }
        </div>
    )
}
